import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasReadAccess } from '../../utils/accessControl';

const ProtectedRoute = ({ children, requiredSession }) => {
  const checkAccess = () => {
    // If no specific session required, allow access
    if (!requiredSession) {
      return true;
    }

    // Check if user has read access to the required session
    return hasReadAccess(requiredSession);
  };

  return checkAccess() ? children : <Navigate to="/unauthorized" replace />;
};

export default ProtectedRoute;